import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'
import { FinanceEntityIdSchema } from '../finance/finance-entity-id.ts'
import { EmailAddressSchema } from '../property.models.ts'
import { NameSchema, PhoneNumberSchema } from '../property.models.ts'

import { generateRandomString } from '@mntn-dev/utilities'
export const BillingContactIdSchema = z.string().brand('billing-contact')

export type BillingContactId = z.infer<typeof BillingContactIdSchema>

export const BillingContactId = (
  value: string = generateRandomString()
): BillingContactId => {
  return BillingContactIdSchema.parse(value)
}

export const BillingContactDomainSelectModelSchema = z.object({
  billingContactId: BillingContactIdSchema,
  financeEntityId: FinanceEntityIdSchema,
  firstName: NameSchema,
  lastName: NameSchema,
  email: EmailAddressSchema,
  phone: PhoneNumberSchema.optional(),
})

export type BillingContactDomainSelectModel = ZodSimplify<
  typeof BillingContactDomainSelectModelSchema
>

export const BillingContactDomainInsertModelSchema =
  BillingContactDomainSelectModelSchema.omit({
    billingContactId: true,
  })

export type BillingContactDomainInsertModel = ZodSimplify<
  typeof BillingContactDomainInsertModelSchema
>

export const BillingContactDomainUpdateModelSchema =
  BillingContactDomainSelectModelSchema.omit({
    financeEntityId: true,
  })

export type BillingContactDomainUpdateModel = ZodSimplify<
  typeof BillingContactDomainUpdateModelSchema
>
